export default __webpack_public_path__ + "static/media/3stepweightloss_1@3x.79f39cee.jpg";